// The Vue build version to load with the `import` commandnpm install
import Es6Promise from 'es6-promise'

import 'babel-polyfill'
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import AutocompleteInput from '@/components/common/AutocompleteInput'
import Popup from '@/components/common/Popup'
import vSelect from 'vue-select'
import VeeValidate from 'vee-validate'
import Icon from 'vue-awesome/components/Icon'
import Datepicker from 'vuejs-datepicker'
import VueEditor from 'vue2-editor'
import AppSpiner from './components/common/AppSpiner.vue'
// import VueAnalytics from 'vue-analytics'
import VueTimeago from 'vue-timeago'
import ZyDialog from 'vue-zydialog'
import 'eventsource-polyfill'
import Vueditor from 'vueditor'
import 'vueditor/dist/style/vueditor.min.css'

import wysiwyg from 'vue-wysiwyg'
import 'vue-wysiwyg/dist/vueWysiwyg.css'

import vClickOutside from 'v-click-outside'

import Tabs from './components/common/tabs/Tabs'
import Tab from './components/common/tabs/Tab'

// import VuePapaParse from 'vue-papa-parse'

Es6Promise.polyfill()

let config = {
  toolbar: [
    'element', 'bold', 'italic', 'underline', 'strikeThrough', 'foreColor', 'divider',
    'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'divider',
    'insertOrderedList', 'insertUnorderedList', 'divider',
    'indent', 'outdent', 'divider',
    'link', 'unLink', 'picture', 'table', 'mixins', 'divider',
    'sourceCode', 'removeFormat', 'undo', 'redo'
  ]
}

Vue.use(Vueditor, config)
Vue.use(VueEditor)
Vue.use(ZyDialog)
Vue.prototype.$eventHub = new Vue()
Vue.config.productionTip = false

Vue.use(wysiwyg, {
  maxHeight: '400px'
})

Vue.component('autocomplete-input', AutocompleteInput)
Vue.component('icon', Icon)
Vue.component('v-select', vSelect)
Vue.component('popup', Popup)
Vue.component('datepicker', Datepicker)
Vue.component('app-spiner', AppSpiner)

Vue.component('tabs', Tabs)
Vue.component('tab', Tab)

Vue.use(VueResource)
Vue.use(Vuex)
Vue.use(VeeValidate)

Vue.use(vClickOutside)

// Vue.use(VueEditor)

// Vue.use(VuePapaParse)

// let analyticsOptions = {
//   id: location.hostname === 'clearassured.co.uk' ? 'UA-109158598-1' : 'UA-159201103-1',
//   router
// }
//
// let userData = localStorage.getItem('userData')
//
// if (userData) {
//   userData = JSON.parse(userData)
//   analyticsOptions['fields'] = {
//     userId: userData.id,
//     dimension1: 'SOME_INDUSTRY_NAME',
//     contentGroup1: 'SOME_INDUSTRY_NAME'
//   }
//   // Vue.$ga.set('dimension1', 'SOME_INDUSTRY_NAME')
// }
//
// console.log(analyticsOptions)
//
// Vue.use(VueAnalytics, analyticsOptions)
//
// Vue.$ga.event('Search', 'filter', 'see all results')

Vue.use(VueTimeago, {
  name: 'timeago', // component name, `timeago` by default
  locale: 'en-US',
  locales: {
    // you will need json-loader in webpack 1
    'en-US': require('vue-timeago/locales/en-US.json')
  }
})

Vue.filter('firstLetter', function (value) {
  return value ? value.charAt(0) + '.' : ''
})

Vue.filter('maxCharacters', function (s, n) {
  if (!s) {
    return s
  }
  if (n === 0) {
    return s
  }
  let totalCount = 0
  let content = ''
  let regex = /<\s*(\w+\b)(?:(?!<\s*\/\s*\1\b)[\s\S])*<\s*\/\s*\1\s*>|\S+/g
  let splitSTR = s.match(regex)
  splitSTR.forEach(function (item) {
    let newRegex = /<(?:[^>=]|='[^']*'|="[^"]*"|=[^'"][^\s>]*)*>/g
    let cleanItem = item.replace(newRegex, '')
    if (totalCount <= n) {
      totalCount += cleanItem.length
      content += ' ' + item
    }
  })
  return content
})

Vue.filter('striphtml', function (value) {
  let div = document.createElement('div')
  div.innerHTML = value
  let text = div.textContent || div.innerText || ''
  return text
})

Vue.filter('nl2br', function (value) {
  return (value || '').replace(/(?:\r\n|\r|\n)/g, '<br />')
})

Vue.http.interceptors.push((request, next) => {
  let impersonated = localStorage.getItem('impersonated')
  if (impersonated) {
    request.params['_switch_user'] = impersonated
    next()
  }
})

Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (response.status === 301) {
      if (response.body && response.body.url) {
        router.push(response.body.url)
      }
    }
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js